import type { Produto } from "@/components/vitrine/types/produto.props"
import { priceFormatter } from "@/utils/formatter"

interface DadosProdutoProps {
    produto: Produto
    precoPrincipal: number
    vitrineButtonAddToCart: string
}

export function DadosProduto({ produto, precoPrincipal, vitrineButtonAddToCart }: Readonly<DadosProdutoProps>) {
    const valorBoleto = produto.valor_boleto
    const valorParcelado = produto.valor_cartao
    const valorPix = produto.valor_pix
    const valorDe = produto.valor_de

    let percentualDesconto: number | null = null

    if (precoPrincipal === 1 && valorBoleto > 0 && valorDe && valorDe > valorBoleto) {
        percentualDesconto = Math.round(
            100 - (valorBoleto / valorDe) * 100
        );
    }
    if (precoPrincipal === 4 && valorPix > 0 && valorDe && valorDe > valorPix) {
        percentualDesconto = Math.round(
            100 - (valorPix / valorDe) * 100
        );
    }
    const hasOldPrice = Boolean(valorDe && valorDe > valorBoleto)
    return (
        <div className="dados-produto">
            {hasOldPrice && (
                <span className="old-price">
                    de <span>{priceFormatter.format(valorDe)}</span> por
                </span>
            )}

            <span className="valor-produto flex column">
                <span className="valor-big">
                    {precoPrincipal === 2 ? (
                        valorParcelado[5] ? (
                            priceFormatter.format(valorParcelado[5].valor)
                        ) : valorParcelado[0] ? (
                            priceFormatter.format(valorParcelado[1])
                        ) : null
                    ) : precoPrincipal === 4 ? (
                        valorPix > 0 ? priceFormatter.format(valorPix) : null
                    ) : valorBoleto > 0 ? (
                        priceFormatter.format(valorBoleto)
                    ) : null}
                </span>
                
                <span className="type-payment">
                    {precoPrincipal === 2 ? (
                        valorParcelado[5] ? (
                            <>no cartão em {valorParcelado[5].parcelas}x de {priceFormatter.format(valorParcelado[5].valorParcela)}</>
                        ) : valorParcelado[0] ? (
                            <>no cartão em {valorParcelado[0]}x de {priceFormatter.format(valorParcelado[2])}</>
                        ) : null
                    ) : precoPrincipal === 4 ? (
                        valorPix > 0 && "no pix"
                    ) : valorBoleto > 0 ? (
                        "no boleto"
                    ) : null}
                </span>
            </span>

            {(percentualDesconto && percentualDesconto > 0) && (
                <div className="desconto">
                    {percentualDesconto}% de desconto
                </div>
            )}
            
            <button className="button button-buy">
                {vitrineButtonAddToCart}
            </button>
        </div>
    )
}